import { Dialog, DialogContent } from "@/components/ui/dialog";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";

export interface CommandAction {
  id: string;
  label: string;
  hint?: string;
  onSelect: () => void;
}

interface MarketingCommandPaletteProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  actions: CommandAction[];
}

export function MarketingCommandPalette({ open, onOpenChange, actions }: MarketingCommandPaletteProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="p-0 sm:max-w-[600px]">
        <Command className="border border-border bg-background text-foreground">
          <CommandInput placeholder="Search marketing actions…" className="placeholder:text-muted-foreground" />
          <CommandList>
            <CommandEmpty>No actions found.</CommandEmpty>
            <CommandGroup heading="Marketing">
              {actions.map((action) => (
                <CommandItem
                  key={action.id}
                  value={action.label}
                  onSelect={() => {
                    action.onSelect();
                    onOpenChange(false);
                  }}
                >
                  <div className="flex w-full items-center justify-between">
                    <span>{action.label}</span>
                    {action.hint ? <span className="text-xs text-muted-foreground">{action.hint}</span> : null}
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </DialogContent>
    </Dialog>
  );
}
